import {Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {SwalComponent} from '@sweetalert2/ngx-sweetalert2';
import {AutomatBrandService} from '../services/automat-brand.service';
import {ActivatedRoute, Router} from '@angular/router';
import {NgxSpinnerService} from 'ngx-spinner';
import {AutomatBrand} from '../models/automatBrand';
import {environment} from '../../environments/environment';
import {ImageService} from '../services/image.service';
import {AutomatModelService} from '../services/automat-model.service';
import {AutomatModel} from '../models/automatModel';


declare var $: any;

@Component({
    selector: 'app-automat-brand-detail',
    templateUrl: './automat-brand-detail.component.html',
    styleUrls: ['./automat-brand-detail.component.css']
})
export class AutomatBrandDetailComponent implements OnInit {
    @ViewChild('closeCreateModal') closeCreateModal: ElementRef;
    @ViewChild('closeUpdateModal') closeUpdateModal: ElementRef;
    @ViewChild('errorSwal') private errorSwal: SwalComponent;
    @ViewChild('successSwal') private successSwal: SwalComponent;

    // Resim ekleme değişkenleri
    @ViewChild('cropInput') cropInput: ElementRef;
    imageChangedEvent: any = '';
    croppedImage: any = '';
    cropperReady = false;
    newModelSprial = false;
    oldRow = 0;
    rowList = [];

    // END : Resim ekleme değişkenleri

    // Düzenleme resim ekleme değişkenleri
    @ViewChild('editCropInput') editCropInput: ElementRef;
    editImageChangedEvent: any = '';
    editCroppedImage: any = '';
    editCropperReady = false;
    // END : Resim ekleme değişkenleri

    ModelImagePath: string;
    model: AutomatModel; // Object for Bootstrap modals
    editModelName = ''; // Edit product modal title
    deleteIndexForModel = -1; // Current product array index

    // Selected filter variables
    selectedCategory = '';
    selectedBrand = '';
    selectedSearchText = '';
    // END : Selected filter variables

    totalCountOfModel = 0;

    // Datas comming from service for select tags
    public models = Array<AutomatModel>();
    public automatBrandId: string;
    public automatBrand: AutomatBrand;

    public selectedName = '';
    public title = '';
    public errorMessage = '';
    public selectedId;
    public searchText;
    page = 1;
    pages = 1;
    backUrl = '/';
    param: string;

    selector: string = '.model-list';

    constructor(
        private automatBrandService: AutomatBrandService,
        private automatModelService: AutomatModelService,
        private router: Router,
        private route: ActivatedRoute,
        private spinner: NgxSpinnerService,
        private imageService: ImageService,
    ) {
        this.ModelImagePath = environment.AutomatImagePath;
    }

    ngOnInit() {
        this.spinner.show();
        this.backUrl = '/automat-brands';
        this.title = 'Modeller';
        this.automatBrandId = localStorage.getItem('automatBrandId');
        if (this.automatBrandId !== null || this.automatBrandId !== '' || this.automatBrandId !== undefined ) {
            this.clearModel();
            this.getBrand(this.automatBrandId);
            this.getAllModels();
            this.spinner.hide();
        } else {
            this.router.navigate([this.backUrl]);
        }
    }
    getBrand(brandId: string) {
        if (!brandId) { return; }
        this.automatBrandService.getBrand(brandId).subscribe(res => {
            this.automatBrand = res.result[0];
            this.title = this.automatBrand.name;
            this.model.automatBrand = this.automatBrand._id;
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
            }
        });

    }
    getAllModels() {
        this.page = 1;
        this.spinner.show();
        this.automatModelService.searchModels(this.page, this.automatBrandId , this.searchText).subscribe(res => {
            this.models = res.docs;
            this.pages = res.pages;
            this.totalCountOfModel = res.total;
            this.spinner.hide();
        }, error => {
            if (error.status === 403) {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
            } else {
                this.spinner.hide();
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
            }
        });
    }

    nextSpiral() {
        this.newModelSprial = true;
        const allSpiral = this.model.row * this.model.column;
        if (this.model.spiralNumberList.length !== allSpiral || this.model.row !== this.oldRow) {
            this.oldRow = this.model.row;
            this.model.spiralNumberList = [];
            this.rowList = [];
            for (let i = 0; i < this.model.row; i++) {
                let columnList = [];
                for (let j = 0; j < this.model.column; j++) {
                    columnList.push(
                        {
                            'row': i,
                            'col': j,
                            'realRowCol': 0,
                            'spiralNumber': 0,
                        }
                    );
                }
                this.rowList.push(columnList);
            }
            console.log(this.rowList);
        }
    }
    prevSpiral() {
        this.newModelSprial = false;
    }

    generateSpiralTemplate() {
        this.model.spiralNumberList = [];
        for (const row of this.rowList) {
            for (const col of row) {
                this.model.spiralNumberList.push(col);
            }
        }
    }
    addModel() {
        if (!this.checkIsFieldsOkay()) { return; }
        this.spinner.show();
        if (this.isExist(this.model.name, 0)) {
            this.errorMessage = 'Bu isimli bir model mevcuttur!';
            this.spinner.hide();
            return;
        }
        this.generateSpiralTemplate();
        // if (this.automatBrandId) { this.model.automatBrand = this.automatBrand}
        this.automatModelService.createModel(this.model).subscribe(response => {
            if (this.croppedImage && this.croppedImage !== '') {
                let fileName = this.cropInput.nativeElement.files[0].name;
                fileName = fileName.split('.');
                const formData = new FormData();
                const ImageFile = this.convertToFile(this.croppedImage,
                    fileName[0] + '_' + response.automatModel._id + '.' + fileName[1]);
                formData.append('upfile', ImageFile);

                this.imageService.automatModelImageUpload(formData, response.automatModel._id ).subscribe(
                    res => {
                        this.successSwal.text = 'Model başarıyla oluşturuldu!';
                        this.successSwal.show();
                    }, error => {
                        this.spinner.hide();
                        this.errorSwal.text = 'Model resmi yüklenirken hata oluştu!';
                        this.errorSwal.show();
                    });
                this.getBrand(this.automatBrandId);
                this.getAllModels();
                this.clearModel();
                this.spinner.hide();
                this.closeCreateModal.nativeElement.click();
            } else {
                this.spinner.hide();
                this.successSwal.text = 'Model resimsiz şekilde başarıyla oluşturuldu!';
                this.successSwal.show();
                this.closeCreateModal.nativeElement.click();
                this.getBrand(this.automatBrandId);
                this.getAllModels();
                this.clearModel();
            }
        }, error => {
            this.spinner.hide();
            this.errorSwal.text = 'Model oluşturulurken hata oluştu!';
            this.errorSwal.show();
        });

    }
    updateModel() {
        if (!this.checkIsFieldsOkay()) { return; }
        if (this.isExist(this.model.name, this.model._id)) {
            this.errorMessage = 'Bu isimli bir model mevcuttur!';
            this.spinner.hide();
            return;
        }

        this.automatModelService.updateModel(this.model, this.model._id).subscribe(response => {
            if (this.editCroppedImage && this.editCroppedImage !== '') {
                let fileName = this.editCropInput.nativeElement.files[0].name;
                fileName = fileName.split('.');
                const formData = new FormData();
                const ImageFile = this.convertToFile(this.editCroppedImage,
                    fileName[0] + '_' + this.model._id + '.' + fileName[1]);
                formData.append('upfile', ImageFile);
                this.imageService.automatModelImageUpload(formData, this.model._id).subscribe(
                    res => {
                        this.successSwal.text = 'Model başarıyla güncellendi!';
                        this.successSwal.show();
                    }, error => {
                        this.errorSwal.text = 'Model resmi güncellenirken hata oluştu!';
                        this.errorSwal.show();
                    });
                this.closeUpdateModal.nativeElement.click();
                this.getBrand(this.automatBrandId);
                this.getAllModels();
                this.clearModel();
                this.spinner.hide();
            } else {
                this.spinner.hide();
                this.successSwal.text = 'Model resmi değiştirilmeden başarıyla güncellendi!';
                this.successSwal.show();
                this.closeUpdateModal.nativeElement.click();
                this.getBrand(this.automatBrandId);
                this.clearModel();
                this.getAllModels();
            }
        }, error => {
            this.spinner.hide();
            this.errorSwal.text = 'Model güncellenirken hata oluştu!';
            this.errorSwal.show();
        });


    }
    deleteModel(_id) {
        this.spinner.show();
        this.deleteIndexForModel = this.models.indexOf(this.models.find(x => x._id === _id));
        this.automatModelService.deleteModel(_id).subscribe(res => {
            this.successSwal.text = 'Model başarıyla silindi!';
            this.successSwal.show();
            this.closeUpdateModal.nativeElement.click();
            this.models.splice(this.deleteIndexForModel, 1);
            this.spinner.hide();
        }, error => {
            this.spinner.hide();
            if (error.retCode !== 1) {
                this.errorSwal.text = 'Model silinirken hata oluştu!';
                this.errorSwal.show();
            } else {
                this.errorSwal.text = 'Ürünü ürün havuzundan silebilmek için önce firma ürünleri içerisinden çıkarmanız gerekmektedir!';
                this.errorSwal.show();
            }
        });
    }
    clearModel() {
        this.newModelSprial = false;
        this.model = new AutomatModel();
        this.model.status = -1;
        this.model.vendingCommunicationProtocol = 1;
        this.model.spiralNumberList = [];
        this.model.pulseTimeSensitive = false;
        if (this.automatBrandId) { this.model.automatBrand = this.automatBrand?this.automatBrand._id:''; }
        this.model.indexKey = 0;
        this.errorMessage = '';

        // Reset image croppers
        this.cropInput.nativeElement.value = '';
        this.imageChangedEvent = '';
        this.croppedImage = '';
        this.cropperReady = false;
        // ----------------------------------------
        this.editCropInput.nativeElement.value = '';
        this.editImageChangedEvent = '';
        this.editCroppedImage = '';
        this.editCropperReady = false;
        // END : Reset image croppers
    }
    setModel(model) {
        this.clearModel();
        this.model = Object.assign({}, model);
        this.editModelName = model.name;
    }
    checkIsFieldsOkay(): boolean {
        console.log('model', this.model)
        let isOkay = true;
        if (this.model.name === '' || this.model.name === undefined) { isOkay = false; }
        if (this.model.description === '' || this.model.description === undefined) { isOkay = false; }
        if (this.model.status.toString() === '-1' || this.model.status === -1 || this.model.status === undefined) { isOkay = false; }
        if (this.model.automatBrand === null || !this.model.automatBrand) { isOkay = false; }
        if (this.model.column <= 0 || this.model.productCount <= 0 || this.model.row <= 0 || this.model.capacity <= 0 || this.model.indexKey == -1) { isOkay = false; }
        if (!isOkay) {
            this.errorSwal.text = 'Lütfen tüm alanları doldurunuz ve negatif değerler girmeyiniz!';
            this.errorSwal.show();
            return false;
        } else {
            return true;
        }
    }
    convertToFile(base64Str, fileName: string) {
        const binary = atob(base64Str.base64.split(',')[1]);
        const array = [];
        for (let i = 0; i < binary.length; i++) {
            array.push(binary.charCodeAt(i));
        }
        return new File([new Uint8Array(array)], fileName , {type: 'image/jpeg', lastModified: Date.now()});
    }
    // Image crop functions
    fileChangeEvent(event: any, isEdit: boolean): void {
        if (isEdit) {
            this.editImageChangedEvent = event;
        } else {
            this.imageChangedEvent = event;
        }
    }

    imageCropped(image: string, isEdit: boolean) {
        if (isEdit) {
            this.editCroppedImage = image;
        } else {
            this.croppedImage = image;
            console.log(this.croppedImage);
        }
    }
    imageLoaded(isEdit: boolean) {
        if (isEdit) {
            this.editCropperReady = true;
        } else {
            this.cropperReady = true;
        }
    }
    imageLoadFailed () {
        this.errorSwal.text = 'Seçtiğiniz resim işlenirken sorun oluştu! Lütfen farklı bir resim deneyiniz';
        this.errorSwal.show();
    }
    // END : Image crop functions
    isExist(modelName, id) {
        let result  = false;
        this.automatModelService.searchModels(this.page, this.automatBrandId , modelName).subscribe(res => {
            result =  res.docs.some(x =>  x.name.toLowerCase() === modelName.toLowerCase() && x._id !== id);
            this.spinner.hide();
            return result;
        }, error => {
            console.log(error);
            if (error.status === 403) {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
            } else {
                this.spinner.hide();
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
            }
        });
        return result;
    }
    searchModel(value) {
        this.spinner.show();
        this.page = 1;
        this.automatModelService.searchModels(this.page, this.automatBrandId, this.searchText)
            .subscribe(response => {
                this.models = response.docs;
                this.pages = response.pages;
                this.spinner.hide();
            }, error => {
                this.spinner.hide();
                this.errorSwal.text = 'Arama sonuçları getirilirken hata oluştu!';
                this.errorSwal.show();
            });
        this.spinner.hide();
    }
    selected(id, name) {
        this.selectedId = id;
        this.selectedName = name;
    }

    sorting() {
        this.models.sort(function(a, b) {
            if (a.name < b.name) { return -1; }
            if (a.name > b.name) { return 1; }
            return 0;
        });
    }
    @HostListener('window:scroll', [])
    onWindowScroll() {
        const verticalOffset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        if (verticalOffset > 400) {
            $('#topButton').fadeIn();
        } else {
            $('#topButton').fadeOut();
        }
    }

    onScroll() {
        if (this.page + 1 > this.pages) { return; }
        $('#page-loader').fadeIn();
        this.page += 1;
        this.automatModelService.searchModels(this.page, this.automatBrandId, this.searchText)
            .subscribe(response => {
                $('#page-loader').fadeOut();
                for (const item of response.docs) {
                    this.models.push(item);
                }
                this.pages = response.pages;
            }, error => {
                $('#page-loader').fadeOut();
                this.errorSwal.text = 'Ürünlerin devamı yüklenemedi!';
                this.errorSwal.show();
            });
    }
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/automat-brand-detail/automat-brand-detail.component.ts